import { createAction } from '@reduxjs/toolkit';
import { CursorUpdatePayload } from 'utils/whiteboard/BoardStateManager';
import { WhiteboardCreatedPayload } from 'features/content-library/types';
import { SignalingEventPayload } from 'services/signaling';
import { BulkCloseContentScope } from 'features/layout/types';
import {
  BulkCloseContentPayload,
  RemoteWBUpdatePayload,
  SignalingWhiteboardClosedPayload,
  SignalingWhiteboardPayload,
  WhiteboardAlreadyOpenedPayload,
  WhiteboardCreatedOptions,
  SignalingContentPushedPayload,
} from './types';

export const whiteboardOpened = createAction<string>('layout/whiteboardOpened');
export const whiteboardClosed = createAction<string>('layout/whiteboardClosed');
export const whiteboardCreated = createAction<WhiteboardCreatedOptions>('layout/whiteboardCreated');

export const signalingWhiteboardOpened = createAction<
  SignalingEventPayload<SignalingWhiteboardPayload>
>('signaling/whiteboardOpened');
export const signalingWhiteboardClosed = createAction<SignalingWhiteboardClosedPayload>(
  'signaling/whiteboardClosed'
);
export const bulkWhiteboardsClosed = createAction<string[]>('layout/bulkWhiteboardsClosed');
export const signalingWhiteboardCreated = createAction<WhiteboardCreatedPayload>(
  'signaling/whiteboardCreated'
);
export const signalingWhiteboardChanged = createAction<RemoteWBUpdatePayload>(
  'signaling/whiteboardChanged'
);

export const signalingWhiteboardCursorUpdated = createAction<CursorUpdatePayload>(
  'signaling/whiteboardCursorUpdated'
);
export const signalingWhiteboardAlreadyOpened = createAction<WhiteboardAlreadyOpenedPayload>(
  'signaling/whiteboardAlreadyOpened'
);

export const contentPushed = createAction('layout/contentPushed');

export const contentLocked = createAction('layout/contentLocked');

export const signalingContentPushed =
  createAction<SignalingContentPushedPayload>('signaling/contentPushed');

export const contentUnlocked = createAction('layout/contentUnlocked');

export const navigateToLockedContent = createAction('layout/navigateToLockedContent');

export const signalingContentUnlocked = createAction('signaling/content/unlocked');

export const bulkCloseContentRequested = createAction<BulkCloseContentScope>(
  'layout/bulkCloseContentRequested'
);

export const signalingBulkContentClosed = createAction<BulkCloseContentPayload>(
  'signaling/bulkContentClosed'
);
